import { render, staticRenderFns } from "./NoticeboardIssue.vue?vue&type=template&id=58dedd98&scoped=true"
import script from "./NoticeboardIssue.vue?vue&type=script&lang=js"
export * from "./NoticeboardIssue.vue?vue&type=script&lang=js"
import style0 from "./NoticeboardIssue.vue?vue&type=style&index=0&id=58dedd98&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dedd98",
  null
  
)

export default component.exports